import * as React from 'react';
import { Router, Switch, Route } from 'react-router-dom'
import PermisosApp from '../components/permisos.json'
import MisPedidosTienda from '../pages/mispedidostienda'
import ReclamosTienda from '../pages/reclamostienda'
import { createBrowserHistory } from 'history'
import CargarPedidoTienda from '../pages/cargarpedidotienda';
import MisComprobantes from '../pages/miscomprobantes';

export default class Canje extends React.Component {
    constructor(props){
      super(props);
      this.state={
        render:[],
        results: [],
        links: [],
        accordion: false,
        urlRedirect:""
      }
    }

    history = createBrowserHistory()
    
    setLinks = this.props.setLinks

    componentDidMount() {

      this.setState({
        urlRedirect: "/ClubParadaOnline"
      })
    }

    allowedLinks = (arrLinks) => {
      const Links = JSON.parse(localStorage.infoToken)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
      const allowedLinks = arrLinks.map((e, index, self) => {
        const { path } = e.props
        if (path.toLowerCase().includes("clubparadaonline")) {
          const initSlice = path.indexOf('/', path.indexOf('/') + 1)
          const stringlink = path.slice(initSlice + 1, undefined)
          const permisosUser = Links.filter(e => e.includes(stringlink))
          if(permisosUser.length > 0) {
            return e
          }
        } else {
          return e
        }
      })
      return allowedLinks
    }

    componentWillUnmount() {
      this.props.hideMenu(true)
    }

    render(){
      const {urlRedirect} = this.state;

      return (
        <React.Fragment>
        <Router history={ this.props.props.history } > 
            <Switch>
              <Route exact path={urlRedirect} render={ (props) => {
                const Links = JSON.parse(localStorage.infoToken)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
                const LinksApp = Links.filter(e => PermisosApp.includes(e))
                          const primerlink = LinksApp.filter(e => e.toLowerCase().indexOf("clubparadaonline.mispedidos") !== -1)[0]
                                          || LinksApp.filter(e => e.toLowerCase().indexOf("clubparadaonline.reclamos") !== -1)[0]
               if (primerlink && primerlink.toLowerCase().indexOf("clubparadaonline.mispedidos") !== -1) {
                  return <MisPedidosTienda hideMenu={this.props.hideMenu} props={props}  />
                } else if (primerlink && primerlink.toLowerCase().indexOf("clubparadaonline.reclamos") !== -1) {
                  return <ReclamosTienda hideMenu={this.props.hideMenu} props={props}  />
                } else if (primerlink && primerlink.toLowerCase().indexOf("clubparadaonline.miscomprobantes") !== -1) {
                  return <MisComprobantes hideMenu={this.props.hideMenu} props={props}  />
                }  else {
                  return <div></div>
                }
                
              } }/>
              {this.allowedLinks([
                <Route key={1} exact path={urlRedirect+"/MisPedidos"} render={ (props) => <MisPedidosTienda hideMenu={this.props.hideMenu} props={props}/> }/>,
                <Route key={2} exact path={urlRedirect + "/Reclamos"} render={(props) => <ReclamosTienda props={props} hideMenu={this.props.hideMenu} />} />,
                <Route key={3} exact path={urlRedirect + "/CargarPedido"} render={(props) => <CargarPedidoTienda props={props} hideMenu={this.props.hideMenu} />} />,
                <Route key={4} exact path={urlRedirect + "/MisComprobantes"} render={(props) => <MisComprobantes props={props} hideMenu={this.props.hideMenu} />} />
              ])}
            </Switch>
          </Router>
        </React.Fragment>
        )
    }
} 